<template>
  <div>
    <!-- Notification Tabs -->
    <section id="notification-tabs" class="mb-5">
      <pdl-tabs>
        <pdl-tab-pane
          v-for="(cat, index) in categories"
          :key="`${index}-${count[cat]}`"
          :label="`${getBaseProperty(cat)} (${count[cat]})`"
        >
          <notification-tab
            :tab-data="filteredTabData[cat]"
            :no-item="noItemMessages[index]"
            :mark-as-read-msg="getBaseProperty('markAsRead')"
            @update:notification-read="updateNotification"
            @update:notification-read-all-marked="updateAllMarkedAsRead"
          />
        </pdl-tab-pane>
      </pdl-tabs>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import find from 'lodash/find';

export default {
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => ['announcements', 'orders', 'stockwatch', 'warranty'],
    },
  },
  data() {
    return {
      noItemMessages: [],
    };
  },
  computed: {
    filteredTabData() {
      return this.notifications !== null
        ? {
            warranty: this.notifications.filter((notification) => notification.category.name === 'Warranty'),
            orders: this.notifications.filter((notification) => notification.category.name === 'Orders'),
            stockwatch: this.notifications.filter((notification) => notification.category.name === 'Stock Watch'),
            announcements: this.notifications.filter((notification) => notification.category.name === 'Announcements'),
          }
        : {};
    },
    count() {
      return this.notifications
        ? {
            warranty: this.filteredTabData.warranty.filter((notification) => !notification.readStatus).length,
            orders: this.filteredTabData.orders.filter((notification) => !notification.readStatus).length,
            stockwatch: this.filteredTabData.stockwatch.filter((notification) => !notification.readStatus).length,
            announcements: this.filteredTabData.announcements.filter((notification) => !notification.readStatus).length,
          }
        : {
            warranty: 0,
            orders: 0,
            stockwatch: 0,
            announcements: 0,
          };
    },

    ...mapGetters('notifications', ['notifications']),
  },
  created() {
    this.fetchNotifications(true);
    this.setNoItemMessages();
  },
  methods: {
    getBaseProperty(name) {
      let baseProperty = find(this.baseProperties, (baseProperty) => baseProperty.name === name);
      return baseProperty ? baseProperty.label : '';
    },
    updateNotification(id) {
      this.updateNotificationRead(id);
    },
    updateAllMarkedAsRead() {
      let selectedIds = this.notifications.filter((item) => item.active === true).map((item) => item.id);
      return selectedIds.forEach((id) => this.updateNotificationRead(id));
    },
    setNoItemMessages() {
      this.noItemMessages = [
        this.getBaseProperty('noannouncement'),
        this.getBaseProperty('noorder'),
        this.getBaseProperty('nostockwatch'),
        this.getBaseProperty('nowarranty'),
      ];
    },
    ...mapActions('notifications', ['fetchNotifications']),
    ...mapActions('notifications', ['updateNotificationRead']),
  },
};
</script>
